import { useParams } from 'next/navigation'

import {
  ZPaymentMethod,
  TPaymentMethod,
  contractQueries,
} from '@/entities/contract'
import { usePrefetchQuery } from '@/shared/api'
import { useDialog, useScrollState } from '@/shared/lib'

export const DIALOG = {
  ACCOUNT_NOTICE: 'ACCOUNT_NOTICE',
  CARD_PAYMENT: 'CARD_PAYMENT',
} as const

type Params = {
  contractId: string
}

type PaymentDialog = keyof typeof DIALOG

type PaymentRequest = {
  method: TPaymentMethod
}

export const usePayment = () => {
  const params = useParams<Params>()
  const contractId = params?.contractId

  const { prefetch } = usePrefetchQuery()

  const { isOpen, open, close } = useDialog<PaymentDialog>()
  const { scrollIntoView: scrollToPayment } = useScrollState<HTMLDivElement>()

  const reload = () => {
    window.location.reload()
  }

  const checkPaymentEligibility = async () => {
    if (!contractId) {
      return false
    }

    const { success } = await prefetch(
      contractQueries.guestPaymentEligibility({
        contractId: Number(contractId),
      }),
      {
        onConfirm: reload,
      },
    )

    return success
  }

  const requestPayment = async ({ method }: PaymentRequest) => {
    const isPayAvailable = await checkPaymentEligibility()

    if (!isPayAvailable) {
      return
    }

    if (method === ZPaymentMethod.enum.ACCOUNT) {
      scrollToPayment()
      open(DIALOG.ACCOUNT_NOTICE)

      return
    }

    open(DIALOG.CARD_PAYMENT)
  }

  const closeDialog = (key: PaymentDialog) => () => {
    close(key)
  }

  return {
    requestPayment,
    isDialogOpen: isOpen,
    closeDialog,
  }
}
